import {
    ADDITIONAL_PAGE_OPTIONS,
    BTX_BNT,
} from '@vfde-sails/constants';
import {
    getLoginData,
    getSiteStructure,
    PageViewTrackingData,
    TrackingBtx,
    TrackingFlowType,
    TrackingLoginStatus,
    TrackingPageType,
    TrackingProduct,
    TrackingProductType,
    TrackingProposition,
    TrackingTargetAudience,
    TRACKING_PLATFORM_TYPE_RESPONSIVE,
    TRACKING_SITE_AREA_MOBILITY,
    trackIt,
} from '@vfde-sails/tracking';

declare global {
    interface Window {
        [ADDITIONAL_PAGE_OPTIONS]?: AdditionalPageOptions;
    }
}

interface AdditionalPageOptions {
    pageName?: string;
    trackingProductInformation?: {
        sku: string,
        name: string,
        oneTimePrice: number,
        monthlyPrice: number,
    }
}

const createTrackingPageView = (): void => {
    const { additionalPageOptions } = window;

    if (!additionalPageOptions) {
        return;
    }

    const { trackingProductInformation } = additionalPageOptions;

    if (!trackingProductInformation) {
        return;
    }

    const aProducts: TrackingProduct[] = [{
        sku: trackingProductInformation.sku,
        name: trackingProductInformation.name,
        type: TrackingProductType.Tariff,
        priceOnce: trackingProductInformation.oneTimePrice,
        priceMonthly: trackingProductInformation.monthlyPrice,
        proposition: 1,
        units: 1,
    }];

    const aPropositions: TrackingProposition[] = [{
        id: 1,
        name: trackingProductInformation.name,
        targetAudience: TrackingTargetAudience.Consumer,
        retention: TrackingBtx.Bnt,
        productType: 'credit',
        productLine: 'voice',
        productCategory: TrackingProductType.Tariff,
        units: 1,
    }];

    const trackPageViewData: PageViewTrackingData = {
        /* eslint-disable camelcase, @typescript-eslint/naming-convention, jsdoc/require-jsdoc */
        page_levels: getSiteStructure(additionalPageOptions.pageName, BTX_BNT),
        page_type: TrackingPageType.ProductDetail,
        login_status: getLoginData() ? TrackingLoginStatus.LoggedIn : TrackingLoginStatus.NotLoggedIn,
        site_area: TRACKING_SITE_AREA_MOBILITY,
        platform_type: TRACKING_PLATFORM_TYPE_RESPONSIVE,
        flow_type: TrackingFlowType.IotDevice,
        business_transaction_type: TrackingBtx.Bnt,
        line_of_customer: TrackingTargetAudience.Consumer,
        oOrder: {
            aProducts,
            aPropositions,
        },
        /* eslint-enable */
    };

    trackIt('pageview', trackPageViewData);
};

createTrackingPageView();
